import { useEffect, useState } from "react";
import { API } from "@/lib/api";
import { getTemplate, getSize } from "@/lib/poster";

export const isShopifyEmbed = () => new URLSearchParams(window.location.search).get("embed") === "shopify";

const post = (msg) => window.parent.postMessage(msg, "*");

export const useEmbedViewport = (enabled) => {
  const [vp, setVp] = useState({ scroll: 0, vh: window.innerHeight, images: [] });
  useEffect(() => {
    if (!enabled) return undefined;
    const html = document.documentElement;
    html.classList.add("ms-embed");
    const onMsg = (e) => {
      if (e.source !== window.parent || e.origin !== new URL(process.env.REACT_APP_SHOPIFY_STORE_URL).origin) return;
      if (e.data?.type === "ms-product" && Array.isArray(e.data.images)) {
        setVp((v) => ({ ...v, images: e.data.images.filter((u) => typeof u === "string" && u.startsWith("https://")) }));
      }
      if (e.data?.type !== "ms-viewport") return;
      html.style.setProperty("--ms-scroll", `${e.data.scroll}px`);
      html.style.setProperty("--ms-vh", `${e.data.visibleHeight ?? e.data.vh}px`);
      setVp((v) => ({ ...v, scroll: e.data.scroll, vh: e.data.vh }));
    };
    window.addEventListener("message", onMsg);
    const root = document.getElementById("root");
    const ro = new ResizeObserver(() => post({ type: "ms-height", height: root.offsetHeight }));
    ro.observe(root);
    post({ type: "ms-ready", height: root.offsetHeight });
    return () => { window.removeEventListener("message", onMsg); ro.disconnect(); };
  }, [enabled]);
  return vp;
};

export const sendToShopifyCart = (cfg, order, embedded) => {
  const size = getSize(cfg.sizeId);
  const properties = {
    "N° création": order.order_number,
    "Modèle": getTemplate(cfg.templateId).name,
    "Format": size.label,
    "Prénoms": cfg.texts.names,
    "Téléphone": order.customer_phone,
    "Date de l'événement": cfg.eventDate ? cfg.eventDate.split("-").reverse().join("/") : "",
    "Fichier PDF": `${API}/creations/${order.tracking_token}/pdf`,
    "Aperçu": `${API}/track/${order.tracking_token}/preview`,
    "Configuration": `${API}/creations/${order.tracking_token}/configuration`,
    "_ms_token": order.tracking_token,
  };
  const item = { id: order.cart_variant_id, quantity: 1, properties: Object.fromEntries(Object.entries(properties).filter(([, v]) => v)) };
  if (embedded) {
    window.parent.postMessage({ type: "ms-checkout", size: cfg.sizeId, properties: item.properties, variantId: item.id }, new URL(process.env.REACT_APP_SHOPIFY_STORE_URL).origin);
  } else {
    const encoded = btoa(Array.from(new TextEncoder().encode(JSON.stringify(item)), (byte) => String.fromCharCode(byte)).join(""));
    window.location.assign(`${process.env.REACT_APP_SHOPIFY_STORE_URL}/cart#ms-add=${encodeURIComponent(encoded)}`);
  }
};
